import { TranslatePluralHtml } from '@change-corgi/core/react/i18n';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { DecisionMaker } from 'src/app/pages/petitionDetails/shared/types';

type Props = {
	decisionMaker: DecisionMaker;
};

export const ConstituentCount: React.FC<Props> = ({ decisionMaker }) => {
	const { targetPetitionAssociationData } = decisionMaker;
	const { constituentCountAmongSigners, constituentCountAmongSignersLocalized } = targetPetitionAssociationData || {};

	if (!constituentCountAmongSigners || !constituentCountAmongSignersLocalized) {
		return null;
	}

	return (
		<Text>
			<TranslatePluralHtml
				count={constituentCountAmongSigners}
				value="corgi.petition_gamma.decision_makers.constituency"
				replacements={{
					numberOfConstituents: constituentCountAmongSignersLocalized,
					dm: decisionMaker.displayName,
				}}
			/>
		</Text>
	);
};
